import { axiosGalleryClient } from "../config/axiosGalleryClient"

const galleryApiService = () => ({
  home: () => axiosGalleryClient.get("home"),
  featured: () => axiosGalleryClient.get("galleries/featured"),
  galleries: () => axiosGalleryClient.get("galleries"),
  gallery: (id) => axiosGalleryClient.get(`galleries/${id}`),
  galleryByDomain: (domain) =>
    axiosGalleryClient.get(`galleries/domain/${domain}`),
  galleryArtworks: (id, params) =>
    axiosGalleryClient.get(`galleries/${id}/artworks`, { params }),
  galleryArtworksByCollection: (id, collection_slug, params = {}) =>
    axiosGalleryClient.get(
      `galleries/${id}/collections/${encodeURIComponent(collection_slug)}`,
      {
        params,
      },
    ),
  artworks: (params) => {
    return axiosGalleryClient.get(`artworks`, { params })
  },
  search: (params) => {
    return axiosGalleryClient.get(`search`, { params })
  },
  searchGalleries: (params) => {
    return axiosGalleryClient.get(`galleries`, { params })
  },
  artwork: (id) => axiosGalleryClient.get(`artworks/${id}`),
  relatedArtworks: (id) => axiosGalleryClient.get(`artworks/${id}/related`),
  spaces: (params) => axiosGalleryClient.get("spaces", { params }),
  space: (id) => axiosGalleryClient.get(`spaces/${id}`),
  contact: (body) => {
    return axiosGalleryClient.post("contact", body)
  },
  dataCapture: (galleryId, body) => {
    return axiosGalleryClient.post(`galleries/${galleryId}/datacapture`, body)
  },
  contactGallery: (galleryId, body) => {
    return axiosGalleryClient.post(`galleries/${galleryId}/contact`, body)
  },
  inquire: (artworkId, body) => {
    return axiosGalleryClient.post(`artworks/${artworkId}/inquire`, body)
  },
  purchase: (artworkId, body) => {
    return axiosGalleryClient.post(`artworks/${artworkId}/purchase`, body)
  },
  exhibitions: (params) => axiosGalleryClient.get("exhibitions", { params }),
  exhibition: (id) => axiosGalleryClient.get(`exhibitions/${id}`),
  artworksfilters: () => axiosGalleryClient.get("artworks/filters"),
})

export default galleryApiService()
